// @flow

import { Input } from "antd"
import * as React from "react"

type Props = {
  onChange?: Function,
  value?: string,
  placeholder?: string
}

// Fallback PhoneInput component that uses a simple Input when intl-tel-input fails
const PhoneInputFallback = ({
  onChange,
  value,
  placeholder,
  ...props
}: Props): React$Element<any> => {
  const handleChange = (e: SyntheticInputEvent<*>) => {
    if (onChange) {
      onChange(e.target.value)
    }
  }

  return (
    <Input
      {...props}
      className="phone-input"
      data-testid="phone-input"
      type="tel"
      placeholder={placeholder || "Phone number"}
      value={value}
      onChange={handleChange}
    />
  )
}

export default PhoneInputFallback
